import React from "react";
import {
  UpdateCollectionMutationVariables,
  useCollectionQuery,
  useUpdateCollectionMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateCollection] = useUpdateCollectionMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useCollectionQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/collection"} replace />;
  }

  const handleUpdate = async (data: UpdateCollectionMutationVariables) => {
    try {
      await updateCollection({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Koleksiyon güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/collection");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.collection}
      id={id}
      handleUpdate={handleUpdate}
    />
  );
};

export default Update;
